import React from 'react'
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryInput from "../components/EntryInput";
import EntryGrid from "../components/EntryGrid";
import EntrySetting from "../components/EntrySetting";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, initializedata, isEnabled } from '../modules/appLibrary';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs} from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';
import { readonly } from '../modules/formstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const Information = props => {
    const inittabs = [{ label: "基本情報", value: '0' },
        { label: "TAX", value: '1' }
    ]

    const panelsdef = [{ id: "0", name: "基本情報", name2:"Base", hide:false },
        { id: "1", name: "TAX", name2: "Color", hide: false }
    ]
    const G_id = { BASE: "0", IMAGE:"pic", TAX: "1", FILE: "file" }
    const formid = getformid("Information", props.location.search);
    const controller = getcontroller("Information", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const warndescription = useSelector(state => state.form.warndiscription);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const themestyle = useSelector(state => state.form.themestyle);

    const colDefsInit = { field: 'rowid', colId: 'rowid', initialHide: true, hide: true, suppressColumnsToolPanel: true, filter: false };
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const apiReftax = useRef({ grid: undefined, column: undefined });
    const apitax = apiReftax.current;
    const locationstate = useRef(null);    //遷移State

    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [update, setUpdata] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);

    const dispatch = useDispatch();
    const CELLTYPE = CellType();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);

    //データ
    const entrydataRef = useRef(null);
    const taxdataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);

    //列情報
    const taxcolRef = useRef(null);
    const coldefRefs = [
        { id: G_id.TAX, ref: taxcolRef }
    ];

    function statusKey(id) {
        return formid + "entry_" + id;
    }


    const actionurl = {
         "update": "information/Update",
         "upload": "information/Upload"
    }

    const navmenu = [
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
    ]

    function rerender() {
        setUpdata(update ? false : true);
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    //useEffect(() => {
    //    if (isEmpty(corpkey) || isEmpty(account)) return;
    //    //ListTabを取得
    //    fnc.current.postaxios('information/GetEntryPanels', { "panels": panelsdef, "controller": controller, "subkey": subkey },
    //        {
    //            onSuccess: function (data) {
    //                setpanel(data.panels);
    //                if (data.tabs.length === 0) data.tabs = inittabs
    //                dispatch(listtabs(data.tabs));
    //                dispatch(setentrypanel({
    //                    layouts: data.layouts, prelayout: data.prelayout,
    //                    initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
    //                    fitColumn: data.fitColumn
    //                }));
    //                setcolumninfo(data.colinfo);
    //                setcolumns(data.columns);
    //                let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
    //                settextfieldsall(fields);
    //                settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
    //                //列情報初期化
    //                for (let i = 0; i < coldefRefs.length; i++) {
    //                    coldefRefs[i].ref.current = null;
    //                }
    //                if (data.prelayout) {   //レイアウト復元
    //                    RestoreLayout(data.panels, fields);
    //                }
    //                fnc.current.wait(false);
    //           }
    //        });
    //}, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
    }, [menuinfo]);


    function onFirstDataRendered(param, id) {
        if (id === G_id.TAX) {
            apiReftax.current.grid = param.api;
            apiReftax.current.column = param.columnApi;
        }
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try{
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        }catch{ }
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined || panel === G_id.COL) {
            taxdataRef.current = AGRef.current.GetDatasource(apitax.grid);
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.TAX) panelid = 'taxGrid';
        if (id === G_id.FILE) panelid = 'fileGrid';
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }


    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            let target = coldefRefs.find(e => e.table === finallycallback.table);
            if (isEmpty(target)) return;
            Jump(target.id);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, target.api.grid);
        }
    }
    function Save(finallycallback) {
        let coldef = createColDef(textfields, textfields, "0");
        const paramdata = {
            "controller": formid,
            "data": entrydataRef.current,
            "tax": EmptyPanel(G_id.TAX) ? null : AGRef.current.GetDatasource(apitax.grid),
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "coldef": AGRef.current.GetConvertColDef(coldef,true),
            "coldeftax": EmptyPanel(G_id.TAX) ? null : AGRef.current.GetConvertColDef(taxcolRef.current,false),
        }
        storeRowData();
        fnc.current.postaxios("information/SaveEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        fnc.current.success();
                    }
                    else {
                        let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                        fnc.current.showwarndescription(msg, data.warning);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }

    function show() {
        if (isEmpty(columninfo)) {
            //起動
            fnc.current.postaxios('information/GetEntryPanels', { "panels": panelsdef, "controller": controller, "subkey": subkey },
                {
                    onSuccess: function (data) {
                        setpanel(data.panels);
                        if (data.tabs.length === 0) data.tabs = inittabs
                        dispatch(setentrypanel({
                            layouts: data.layouts, prelayout: data.prelayout,
                            initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                            fitColumn: data.fitColumn
                        }));
                        setcolumninfo(data.colinfo);
                        setcolumns(data.columns);
                        let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                        settextfieldsall(fields);
                        settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                        //列情報初期化
                        for (let i = 0; i < coldefRefs.length; i++) {
                            coldefRefs[i].ref.current = null;
                        }
                        if (data.prelayout) {   //レイアウト復元
                            RestoreLayout(data.panels, fields);
                        }
                        LoadData(data.colinfo);
                   }
                });
        } else {
            LoadData(columninfo);
        }
    }
    function LoadData(columninfo) {
        fnc.current.postaxios('information/GetData', { "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        entrydataRef.current = data.data;
                        //行データ
                        if (data.tax.length !== 0) taxdataRef.current = data.tax;
                        imageRef.current = data.images;
                        fileRef.current = data.files;
                        dispatch(setimagelist(data.images));
                        rerender();
                        fnc.current.wait(false);
                   } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                   }
                },
                onError: function (data) {
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    fnc.current.wait(false);
                }
            }
        )
    }
    function createColDef(all, columns, id) {
        var colDef = [
            colDefsInit,
            {
                field: 'grip', colId: 'grip', headerName: " ", rowDrag: true, lockPosition: true, suppressMenu: true,
                width: 40, editable: false, filter: false, sortable: false, resizable: false, suppressColumnsToolPanel: true
            }
        ]
        try {
            for (let i = 0; i < all.length; i++) {
                let hide = false;
                let result = columns.filter(e => e.columnid === all[i].columnid);
                hide = result.length === 0;
                let column = {
                    headerName: all[i].columnnm,
                    field: all[i].columnid,
                    colId: all[i].columnid,
                    width: all[i].width,
                    hide: hide,
                    editable: true
                }
                if (all[i].datatype === CELLTYPE.NUM)
                    column['type'] = 'rightAligned';
                colDef.push(column);
            }
        } catch (error) {
            console.log(error);
        }
        return colDef;
    }
    //入力フィールドクリア
    function clearform(newform) {
        entrydataRef.current = initializedata(textfieldsall, staff);
        taxdataRef.current = null;
        imageRef.current = null;
        fileRef.current = null;
        scrollRef.current = null;

        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
            {
                onSuccess: function (data) {
                    for (let key in data.returnData) {
                        var col = textfieldsall.find(e => e.columnid === key);
                        if (!isEmpty(col)) col.initvalue = data.returnData[key];
                    }
                    entrydataRef.current = initializedata(textfieldsall, staff);
                    rerender();
                },
            }, true
            )
        }
    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, statusKey(G_id.BASE));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < coldefRefs.length; i++) {
            AGRef.current.SaveColState(statusKey(coldefRefs[i].id), EmptyPanel(coldefRefs[i].id) ? null : coldefRefs[i].column);
        }
        //基本情報保存
        Savestorage(corpkey, account, statusKey(G_id.BASE), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            switch (panel[p].id) {
                case G_id.BASE:
                    if (setbase) break;
                    let fds = textfields.filter(x => !x.hide);
                    for (let f = 0; f < fds.length; f++) {
                        coldef.push({
                            headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                            type: fds[f].type
                        });
                    }
                    setbase = true;
                    break;
                case G_id.TAX:
                    cols = AGRef.current.GetshownColDef(apitax.column); break;
                default:
                    continue;
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
               },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < coldefRefs.length; i++) {
                        var type = tabletype(coldefRefs[i].id);
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldefRefs[i].length === 0) continue;
                        coldefRefs[i].ref.current = coldef;
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //パネル別列情報取得
    function tabletype(id) {
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }


    //File Upload 再表示
    function fileuploaded(data) {
        imageRef.current = data.images;
        fileRef.current = data.files;
        dispatch(setimagelist(data.images));
        rerender();
    }
    //File Delete
    function deleteFile(type, filename) {
        saveScrollPos();
        fnc.current.postaxios('information/RemoveFile', { "subkey": filename, "controller": controller },
            {
                onSuccess: function (data) {
                    fileRef.current = fileRef.current.filter(e => e.filename !== filename);
                    rerender();
                    restoreScrollPos();
                    fnc.current.wait(false);
                },
                errmsg: "ファイル削除に失敗しました"
            }
        )
    }
    //基本項目入れ替え
    const onSortEnd = ({ oldIndex, newIndex }, e) => {
        let type = e.target.parentNode.id.replace('basepanel', '');
        let idx = 0;
        for (let i = 0; i < textfields.length; i++) {
            if (textfields[i].type === type) {
                idx = i; break;
            }
        };
        settextfields(arrayMove(textfields, oldIndex + idx, newIndex + idx));
    };
    function shouldCancelStart(e) {
        //Label以外ソート不可
        if (e.target.className !== 'fieldlabel') return true;
    }
    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //基本情報
    function width(value) {
        if (windowDimensions.width <= 600) {
            return '100%';
        }
        if (windowDimensions.width <= 900) {
            let size = ["50%", "50%", "100%", "100%"];
            return size[value];
        } else {
            let size = ["25%", "50%", "75%", "100%"];
            return size[value];
        }
    }
    function ChangeWidth(def, deltaY) {
        let col = textfields.find(e => e.columnid === def.columnid && e.type === def.type);
        if (isEmpty(col)) return;
        if (deltaY > 0) {   //-
            if (col.width === 0) return;
            col.width -= 1;
        } else {            //+
            if (col.width === 3) return;
            col.width += 1;
        }
        settextfields(DeepCopy(textfields));
    }
    const SortableItem = SortableElement(({ value }) => (
        <div style={{ boxSizing: 'border-box', width: width(value.width) , border: 'solid 1px #ccc' }}>
            <div className='fieldlabel' style={{ cursor: 'context-menu', backgroundColor: themestyle.header.back, color: themestyle.header.color }}>
                {value.columnnm}
            </div>
            < div className={'fieldinput'} style={{ position: 'relative', backgroundColor: value.locked || ((value.primary || value.unchange) && formstatus === 'ENTRY FORM') ? '#eee' : (value.required ? themestyle.body.require : 'inset') }}>
                <EntryInput
                    def={value}
                    dataRef={entrydataRef}
                    textfields={textfields}
                    fnc={fnc}
                    changewidth={ChangeWidth}
                />
                {warning(value) ? <WarnTip msg={warndescription.find(e => e.rowid === "0" && e.col === value.columnid).message} conv={false} /> : null}
            </div >
        </div>
    ));
    const SortableList = SortableContainer(({ items }) => {
        return (
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: 'left' }}>
                {items.map((value, index) => (
                    <SortableItem key={`item-${index}`} index={index} value={value} disabled={layoutlock}/>
                ))}
            </div>
        );
    });
    function warning(value) {
        if (warndescription.length === 0) return false;
        const warn = warndescription.find(e => e.rowid === "0" && e.col === value.columnid);
        if (!isEmpty(warn)) {
            return true;
        }
    }
    function WarnTip(param) {
        return (
            <Tooltip title={param.msg}>
                <div style={{ position: 'absolute', top: -2, left: -2, cursor: 'pointer' }}>
                    {param.conv ? < span class="material-icons convert">check_circle</span> : < span class="material-icons warning">announcement</span>}
                </div>
            </Tooltip>
        );
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <SortableList
                        axis={"xy"}
                        items={textfields.filter(e => e.type === props.panel.type)}
                        onSortEnd={onSortEnd}
                        distance={1}
                        shouldCancelStart={shouldCancelStart}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                    deleteurl={'information/RemoveFile'}
                />
            )
        }
       if (props.panel.id === G_id.TAX) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="taxGrid"
                    dataRef={taxdataRef}
                    columnRef={taxcolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.TAX)}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.TAX)}
                    ValueChanged={() => storeRowData(G_id.TAX)}
                    DataRowChanged={() => storeRowData(G_id.TAX)}
                />
            );
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    dataRef={fileRef}
                    deleteFile={deleteFile}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE) return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p,i) => {
                   return (
                        <Box
                           display={panelhidden(p) ? "none" : "flex"}
                           justifyContent="space-around"
                           alignItems="center"
                           padding="5px"
                            >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                           >
                               <div style={{ position: 'relative', marginBottom: 5 }}>
                                   {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                   {p.id !== '0' || layoutlock ? null :
                                       <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                           <IconButton size="small" onClick={()=>SetBaseField(p.type)}  >
                                               <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {layoutlock ? null :
                                       <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                           <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                               <Icon style={{ fontSize: 16 }}>close</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                </div>
                                    <Contents panel={p}/>
                                </Paper >
                           </Box>
                    );
                })}
            </div>
        );
    }
    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                entryform={true}
                entryonly={true}
                show={show}
                navmenu={entrylock ? navmenu.filter(e => e.menuid !== 'formupload') : navmenu}
            >
            <EntryForm />
            </MasterBase>
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            <EntryForm/>
            <div>
                <div style={{ position: 'absolute', top: 60, right: 15 }}>
                    <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                        <Icon>table_chart</Icon>
                    </IconButton>
                </div>
                <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                <div style={{ position: 'absolute', top: 60, left: 210 }}>
                <Paper
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        listStyle: 'none',
                        p: 0.5,
                        m: 0,
                    }}
                    component="ul"
                    elevation={0}
                    style={{ backgroundColor: "transparent" }}
                >
                        {/*Panel Selector*/}
                        <SortablePanelSelector
                            axis={"x"}
                            items={panel}
                            onSortEnd={onPanelSortEnd}
                            distance={2}
                            />
                </Paper>
                </div>
            </div>

            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DropZone
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};

